import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { PropertyType } from "@app/catalog";


@Component({
  selector: "property-item-row",
  standalone: false,
  templateUrl: "./property-item-row.component.html",
  styleUrl: "./property-item-row.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyItemRowComponent {
  public propertyType = input<PropertyType>();
  public name = input.required<string>();
  public value = input.required<string | number | string[]>();

  /**
   * Whether the value is a list of entries that should render as `<li>` items.
   *
   * @returns `true` when `value()` is an array; otherwise `false`.
   */
  public isList = computed(() => Array.isArray(this.value()));

  /**
   * The value entries to render as list items.
   *
   * @returns The value array, or an empty array when `value()` is a scalar.
   */
  public listItems = computed(() => {
    const val = this.value();
    return Array.isArray(val) ? val : [];
  });

  public isNumericValue = computed(() => {
    console.log("Value: ", this.value());
    if (this.propertyType() === PropertyType.RoomContent) {
      const val = this.value();
      if (val === null || val === undefined || val === '') return false;
      const str = String(val).trim();
      // Check if string contains any digit
      return /\d/.test(str);
    }
    return false;
  });
}
